export default __webpack_public_path__ + "img/02000f3131a3c35db9056009298be65c.svg";